<template>
  <video-player
    id="CustomVideoPlayer"
    class="video-player video"
    crossorigin="anonymous"
    playsinline
    ref="elementRef"
    controls
    autoplay="true"
    :tracks="textTracks"
    :src="linkVideo"
    volume="0.4"
    @playing="$emit('playing')"
    @pause="$emit('pause')"
    @timeupdate="handleTimeUpdate"
    :children="['mediaLoader', 'loadingSpinner', 'controlBar', 'textTrackDisplay']"
    :control-bar="{
      volumePanel: true,
    }"
    @waiting="onVideoWaiting"
    @stalled="onVideoStalled"
    @error="onVideoError"
  />
</template>

<script>
import { defineComponent, ref, onMounted, watch, nextTick } from 'vue';
import { VideoPlayer } from '@videojs-player/vue';
import 'video.js/dist/video-js.css';

export default defineComponent({
  components: {
    VideoPlayer,
  },
  props: {
    linkVideo: String,
    textTracks: Array,
    startTime: {
      type: Number,
      default: 0,
    },
  },
  emits: ['timeupdate'],
  setup(props, { emit }) {
    const elementRef = ref(null);
    let lastSecond = -1;

    const handleTimeUpdate = (event) => {
      const video = event.target;
      const currentSec = Math.floor(video.currentTime);

      if (currentSec !== lastSecond) {
        lastSecond = currentSec;
        emit('timeupdate', currentSec);
      }
    };

    const setStartTime = () => {
      nextTick(() => {
        const videoEl = elementRef.value?.$el?.querySelector('video');
        if (videoEl && props.startTime > 0) {
          videoEl.currentTime = props.startTime;
        }
      });
    };

    onMounted(() => {
      const videoEl = elementRef.value?.$el?.querySelector('video');
      if (videoEl) {
        videoEl.addEventListener('timeupdate', handleTimeUpdate);
        setStartTime();
      }
    });

    watch(
      () => props.startTime,
      () => {
        setStartTime();
      }
    );

    return {
      elementRef,
      handleTimeUpdate,
    };
  },
});
</script>

<style lang="scss" scoped>
.video-player {
  background-color: $black;
  width: 100%;
  height: 100vh;
}
</style>
